// import React from "react";
// import "./CredentialHome.css";

// // Reusable CredentialItem component
// const CredentialItem = ({ imageSrc, altText }) => {
//   return (
//     <div className="col-lg-2 col-4 clients-item-height">
//       <img src={imageSrc} className="clients-image img-fluid" alt={altText} />
//     </div>
//   );
// };

// const CredentialHome = () => {
//   // Array of credential data
//   const credential = [
//     { src: "./assets/img/credentials/pharmaceuticals.jpg", alt: "Pharmexcil" },
//     { src: "./assets/img/credentials/duns.png", alt: "D.U.N.S" },
//     { src: "./assets/img/credentials/chemexill.png", alt: "Chemexcil" },
//     { src: "./assets/img/credentials/spices.png", alt: "Spices Board" },
//     {
//       src: "./assets/img/credentials/onestar.jpeg",
//       alt: "One Star Export House",
//     },
//     {
//       src: "./assets/img/credentials/fssai-registration-service.png",
//       alt: "FSSAI",
//     },
//   ];

//   return (
//     <section className="clients section-padding">
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-12 col-12">
//             <h2 className="text-center mb-5 c-section-title">Credentials</h2>
//           </div>

//           {/* Rendering client items dynamically */}
//           {credential.map((client, index) => (
//             <div
//               key={index}
//               className={`col-lg-2 col-4 clients-item-height ${
//                 client.alt === "Pharmexcil" ? "special-size" : ""
//               }`}
//             >
//               <img
//                 src={client.src}
//                 className="clients-image img-fluid"
//                 alt={client.alt}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CredentialHome;

// WIth ANIMATION :1

import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./CredentialHome.css";

// Reusable CredentialItem component with animation
const CredentialItem = ({ imageSrc, altText, specialClass }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <motion.div
      ref={ref}
      className={`col-lg-2 col-4 clients-item-height ${specialClass}`}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0, scale: 1 } : { scale: 0.8 }}
      transition={{ duration: 0.5 }}
    >
      <img src={imageSrc} className="clients-image img-fluid" alt={altText} />
    </motion.div>
  );
};

const CredentialHome = () => {
  // const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  // Array of credential data
  // const credentials = [
  //   {
  //     src: "./assets/img/credentials/pharmaceuticals.jpg",
  //     alt: "Pharmexcil",
  //     special: true,
  //   },
  //   { src: "./assets/img/credentials/duns.png", alt: "D.U.N.S" },
  //   { src: "./assets/img/credentials/chemexill.png", alt: "Chemexcil" },
  //   { src: "./assets/img/credentials/spices.png", alt: "Spices Board" },
  //   {
  //     src: "./assets/img/credentials/onestar.jpeg",
  //     alt: "One Star Export House",
  //   },
  //   {
  //     src: "./assets/img/credentials/fssai-registration-service.png",
  //     alt: "FSSAI",
  //   },
  // ];

  //   return (
  //     <motion.section
  //       ref={ref}
  //       className="clients section-padding"
  //       initial={{ opacity: 0 }}
  //       animate={inView ? { opacity: 1 } : {}}
  //       transition={{ duration: 0.8 }}
  //     >
  //       <div className="container">
  //         <motion.div
  //           className="row align-items-center"
  //           initial={{ opacity: 0, y: -20 }}
  //           animate={inView ? { opacity: 1, y: 0 } : {}}
  //           transition={{ duration: 0.6 }}
  //         >
  //           {/* <div className="col-lg-12 col-12 text-center">
  //             <h2 className="mb-5 c-section-title">g</h2>
  //           </div> */}

  //           {/* Rendering client items dynamically */}
  //           {/* {credentials.map((client, index) => (
  //             <CredentialItem
  //               key={index}
  //               imageSrc={client.src}
  //               altText={client.alt}
  //               specialClass={client.special ? "special-size" : ""}
  //             />
  //           ))} */}
  //         </motion.div>
  //       </div>
  //     </motion.section>
  //   );
};

export default CredentialHome;
